import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SponsorshipsService } from 'src/app/shared/services/sponsorships.service';
import { SponsorshipRequestService } from 'src/app/shared/services/sponsorship-request.service';
import { Auth } from 'aws-amplify';

@Component({
  selector: 'app-view-sponsorship-requests',
  templateUrl: './view-sponsorship-requests.component.html',
  styleUrls: ['./view-sponsorship-requests.component.css']
})
export class ViewSponsorshipRequestsComponent implements OnInit {
  isLoading = false;
  isDeleting = false;
  sponsorshipRequests: any = [];
  deletedSponsoshipReqId: string = "";
  deletedId: string = "";
  owner: any;
  constructor(
    private router: Router, 
    private route: ActivatedRoute, 
    private sponsorshipRequestService: SponsorshipRequestService, 
    ) {
      this.getCurrentAuthenticatedUser();
     }

  ngOnInit(): void {
    this.getSponsorshopReqByStatus(this.owner);
  }

  getCurrentAuthenticatedUser() {
    // this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user.attributes.email);
        this.owner = user.attributes.email;
      },
        (error) => {
          console.log("authentication error", error);
          // this.userNotAuthenticated = error; 

          // this.isHidden = true;
        });
  }

  addSponsorshipRequest() {
    this.router.navigate(['/private-space/add', {}]);

  }

  delete(sponsorshipRequest: any) {
    this.onDeleteSponsorshipRequest(sponsorshipRequest);
  }

  onDeleteSponsorshipRequest(sponsorshipRequest: any) {

    this.isDeleting = true;
    this.deletedId = sponsorshipRequest.sponsorshipRequestId;

    console.log("Delete: ", sponsorshipRequest.sponsorshipRequestId);

    this.sponsorshipRequestService.deleteSponsorshipReq(sponsorshipRequest).subscribe((data) => {
      this.isDeleting = false;
      console.log(data);
      // this.getSponsorshopReqByStatus('NEW');

      setTimeout(() => {
        this.getSponsorshopReqByStatus('NEW');
      }, 2500);

      // window.location.reload();
    }, (err) => {
      this.isDeleting = false;
      console.log("Error deleting: ",err);
      
      setTimeout(() => {
        this.getSponsorshopReqByStatus('NEW');
      }, 2500);
      
    });

  }


  onEditSponsorshipRequest(sponsorshipRequest: any) {
    console.log("Edit: ", sponsorshipRequest);
    const queryParams: Params = sponsorshipRequest;

    this.router.navigate(
      ['/private-space/edit-sporsorship-request'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  onViewSponsorshipRequest(sponsorshipRequest: any) {
    console.log("View: ", sponsorshipRequest);
    const queryParams: Params = sponsorshipRequest;

    this.router.navigate(
      ['/private-space/view-single-sporsorship-request'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  getSponsorshopReqByStatus(owner: string) {
    this.isLoading = true;
    
    this.sponsorshipRequestService.getSponsorshipRequestByStatus(owner).subscribe((data) =>{
      this.isLoading = false;
      console.log("data", data);
      this.sponsorshipRequests = data;
    }, (error) =>{
      console.log("Error", error);
      this.isLoading = false;
      
    });
  }

  onDeleteSponsorshipReq(sponsorshipRequest: any){
    console.log("Deleted: ", sponsorshipRequest);
    this.isLoading = true;
    this.isDeleting = true;
    this.deletedSponsoshipReqId = sponsorshipRequest.sponsorshipRequestId;
    
    this.sponsorshipRequestService.deleteSponsorshipReq(sponsorshipRequest).subscribe((data) =>{
      this.isDeleting = false;
      console.log('Success', data);
      setTimeout(() => {
        this.getSponsorshopReqByStatus(this.owner);
        this.isLoading = false;
      }, 2500);

    }, (error) => {
      setTimeout(() => {
        this.getSponsorshopReqByStatus(this.owner);
        this.isLoading = false;
      }, 2500);
      this.isDeleting = false;

      console.log("Error deleting", error);
      
    });
  }

}
